
$(function() {

  $('.show-reply-form').click(function() {
    var x = document.getElementById(this.dataset.replyFormId);
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  });
});

// function showReplyBox(formTargetId) {
//   console.log("asdasdasda");
  // var x = document.getElementById(formTargetId);
  // if (x.style.display === "none") {
  //   x.style.display = "block";
  // } else {
  //   x.style.display = "none";
  // }
// };
